export default __webpack_public_path__ + "static/media/avatar-process_club_bot.c0a7a9c5.png";